import { render } from "./UserMenu.vue?vue&type=template&id=1b342420&scoped=true&ts=true"
import script from "./UserMenu.vue?vue&type=script&lang=ts"
export * from "./UserMenu.vue?vue&type=script&lang=ts"

import "./UserMenu.vue?vue&type=style&index=0&id=1b342420&lang=scss&scoped=true"

import exportComponent from "/var/www/rewards/runners/app/root/reward-app/reward-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b342420"]])

export default __exports__